<template>
  <BaseModal :is-open="isOpen" :title="title" :hide-body="!body" @close="onCancel">
    <slot>
      {{ body }}
    </slot>
    <template #footer>
      <a
        href="#"
        class="btn btn-regular"
        style="margin-bottom: 0 !important;"
        @click.prevent="onCancel"
      >
        <i class="icon-close" style="margin-right: 4px;"></i> {{ cancelText }}
      </a>
      <a href="#" class="btn" @click.prevent="onConfirm">
        <i class="icon-check" style="margin-right: 4px;"></i> {{ confirmText }}
      </a>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './base/BaseModal';
import eventBus, {
  CONFIRM_DIALOG_CANCELLED,
  CONFIRM_DIALOG_CONFIRMED,
  OPEN_CONFIRM_DIALOG,
} from '@/util/eventBus';

export default {
  name: 'ConfirmationModalEventBus',

  components: { BaseModal },

  data() {
    return {
      isOpen: false,
      title: '',
      body: '',
      cancelText: '',
      confirmText: '',
    };
  },

  created() {
    eventBus.$on(OPEN_CONFIRM_DIALOG, async (options) => {
      this.title = typeof options.title === 'string' ? options.title : this.$t('are_you_sure');
      this.body = typeof options.body === 'string' ? options.body : '';
      this.cancelText =
        typeof options.cancelText === 'string' ? options.cancelText : this.$t('common.no');
      this.confirmText =
        typeof options.confirmText === 'string' ? options.confirmText : this.$t('common.yes');
      this.isOpen = true;
    });
  },

  methods: {
    onConfirm() {
      eventBus.$emit(CONFIRM_DIALOG_CONFIRMED);
      this.isOpen = false;
    },

    onCancel() {
      eventBus.$emit(CONFIRM_DIALOG_CANCELLED);
      this.isOpen = false;
    },
  },
};
</script>
